/**
 * The partner objection (docs/partner-objection.md): one objection for all
 * partners at signup (O1), the welcome sheet at a join (O3), and the "Partner
 * sharing" settings (O4).
 */

/**
 * The wording of the objection screen and of the settings page. The API
 * stamps the same version on each row it writes.
 */
export const OBJECTION_WORDING_VERSION = "objection_v2";
